import React from 'react';
import { createRoot } from 'react-dom/client';
import { Text } from 'react-native';
import { View } from '../src/Components/Themed';
import App from './App';
const rootElement = document.getElementById('root');
if(rootElement){
    const root = createRoot(rootElement);
    root.render(
        <App
        />
    )
}
